module.exports = __webpack_public_path__ + "static/media/dublin-city-university.ee87fd37.png";